import $ from 'jquery';
import 'jquery-match-height';

$('.woocommerce-loop-product__bottom').matchHeight();

// eslint-disable-next-line no-undef
const object = vipersObject;

$('.shop-block-more-with-pub').each(function () {
    const current = $(this);
    const id = current.attr('data-block');
    const data = {
        vars: window[`${id}`],
        action: 'vipers_shop_block_pub',
        nonce: object.nonce,
    };

    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data,
        success: (res) => {
            if (res.success) {
                setTimeout(() => {
                    current.html(res.data.content);
                }, 1000);
            }
        },
    });
});
